
import { Component, OnInit } from '@angular/core';
import { CommonUtilitiesService } from '../common-utilities.service';
import { constants } from '../constants';

@Component({
  selector: 'app-care-channels',
  templateUrl: './care-channels.component.html',
  styleUrls: ['./care-channels.component.scss']
})
export class CareChannelsComponent implements OnInit {

  constructor(public LANG:CommonUtilitiesService) { }
  ngOnInit() {
    
  }

}
